import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = props => {
    return <FontAwesomeIcon {...props} />;
};

export default Icon;